import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { compose } from 'recompose';
import { withStyles, FormControl, InputLabel } from '@material-ui/core';
import makeSelectorInstance from '../../reference/makeSelectorInstance';
import { getSelectedElementResourceId, getSelectedElementOptimizedResourceId } from '../../banner/bannerSelectors';
import { styles } from '../propertyEditorStyles';
import { getBestSize } from '../../resources/resourcesDucks';

class ElementSize extends React.Component {
  state = {
    classState: {},
    imageResourceId: '',
  };

  static getDerivedStateFromProps(nextProps) {
    return {
      classState: { shrink: nextProps.classes.labelShrink },
      imageResourceId: getBestSize(nextProps.optimizedResourceId, nextProps.resourceId),
    };
  }

  render() {
    const { classes } = this.props;
    const { classState, imageResourceId } = this.state;

    return (
      <FormControl fullWidth>
        <InputLabel shrink classes={classState}>
          <FormattedMessage id="properties.image.fileSize" />
        </InputLabel>
        <div className={classes.valueRight}>{imageResourceId} Ko</div>
      </FormControl>
    );
  }
}

const makeStateToProps = () => state => ({
  resourceId: makeSelectorInstance(getSelectedElementResourceId)(state),
  optimizedResourceId: makeSelectorInstance(getSelectedElementOptimizedResourceId)(state),
});

export default compose(
  connect(makeStateToProps),
  withStyles(styles),
)(ElementSize);
